export default async file => {
  const reader = new FileReader()

  return new Promise((resolve, _reject) => {
    reader.onload = () => {
      resolve(reader.result)
    }

    reader.readAsDataURL(file)
  })
}
